import { useController } from '../../../contexts';
import { useClauseCombinatorFieldPath } from '../fieldPaths';

export const useClauseCombinatorController = () => {
  const fieldPath = useClauseCombinatorFieldPath();
  return useController({ name: fieldPath });
};
